<script>
	import Header from "./Header.svelte";
	import Footer from "./Footer.svelte";
	import Home from "./pages/home/Home.svelte";
	import Resume from "./pages/resume/Resume.svelte";
	import Blog from "./pages/blog/Blog.svelte";
	import BlogPost from "./pages/blog/BlogPost.svelte";
	import Photos from "./pages/photos/Photos.svelte";
	import Admin from "./pages/admin/Admin.svelte";
	import {Router, Route} from "svelte-navigator";
	import NotFound from "./components/NotFound.svelte";
	import {initFireBase} from "./config/firebase-config";
	import {onMount} from "svelte";
	import {getAllBlogsFromFireStore, getAllPhotos} from "./config/database-repo";

	onMount(() => {
		initFireBase();
		getAllBlogsFromFireStore();
		getAllPhotos();
	});

</script>
<!--------------------------------------------------------------------------------------------------------------------->

<Router primary={false}>
<div class="page">
	<Header />

	<main>
		<Route path="/"><Home /></Route>
		<Route path="resume"><Resume /></Route>
		<Route path="blog/*">
			<Route path="/"><Blog /></Route>
			<Route path=":id"><BlogPost /></Route>
		</Route>
		<Route path="photos"><Photos /></Route>
		<Route path="admin"><Admin /></Route>
		<Route path="/*"><NotFound /></Route>
	</main>

	<Footer/>
</div>
</Router>

<!--------------------------------------------------------------------------------------------------------------------->

<style>
	.page {
		margin: 0 auto;
		min-height: 100vh;
		max-width: 1000px;
		display: flex;
		flex-direction: column;
	}

	main {
		flex-grow: 1;
		padding: 130px 2px 0;
	}

/*=======================================================================================*/
/*==================================     MEDIA     ======================================*/

	@media screen and (max-width: 500px) {
		.page {
			width: 100vw;
			padding: 0 10px;
			flex-direction: column-reverse;
		}
		main {
			padding-top: 2rem;
			padding-bottom: 2.5rem;
		}
	}
	@media screen and (min-width: 501px) and (max-width: 1000px) {
		.page {
			width: 90%;
		}
	}
</style>